<template>
  <a-card size="small" type="inner" title="Transaction growth">
    <a-skeleton :loading="loading" active>
      <transaction-growth :chart-data="chartData" :options="options"></transaction-growth>
    </a-skeleton>
  </a-card>
</template>

<script>
import TransactionGrowth from "./transaction-growth";
import moment from 'moment'

export default {
  name: "transaction-growth-container",
  components: {TransactionGrowth},
  props: {
    product: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: false,
    items: []
  }),
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product.transaction.growth', {
        product_hash: this.product
      })).then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    },
  },
  computed: {
    chartData() {
      const labels = this.items.map(item => moment(item.reconcile_date).format('DD-MM-YYYY'))

      const data = {
        label: 'Transactions Amount',
        data: this.items.map(item => item.price),
        fill: false
      }

      return {
        labels: labels,
        datasets: [data]
      }
    },
    options() {
      return {
        plugins: {
          colorschemes: {
            scheme: "brewer.DarkTwo3"
          }
        },
      }
    }
  }
}
</script>

